import React from 'react'
import { useTheme } from 'styled-components'
import { useTranslation } from 'react-i18next'

import {
  SubHeader,
  Container,
  Text,
  InnerContainer,
  AddressContainer,
  Description,
} from './CollectionAddress.styles'
import { IconButton } from '@src/components/Button/IconButton'

type OutletForCollectionAddress = {
  outletAddress: {
    firstLine: string
    secondLine: string | null
    thirdLine: string | null
    postcode: string
    city?: string
  }
  restaurant: {
    name: string
  }
}

export const CollectionAddress: React.FC<{
  outlet: OutletForCollectionAddress
  cardOnly?: boolean
  noPad?: boolean
  hideMapButton?: boolean
}> = ({ outlet, cardOnly = false, noPad = false, hideMapButton = false }) => {
  const { t } = useTranslation('checkout')
  const theme = useTheme()

  const { firstLine, secondLine, thirdLine, postcode, city } =
    outlet.outletAddress
  const { restaurant } = outlet

  const handleMapsSearch = () => {
    const address = [firstLine, secondLine, thirdLine, postcode]
      .filter(Boolean)
      .join(' ')
    const query = encodeURIComponent(address)

    window.open(
      `https://www.google.com/maps/search/?api=1&query=${query}`,
      '_blank'
    )
  }

  return (
    <Container $cardOnly={cardOnly} $noPad={noPad}>
      {!cardOnly && <Description>{t('collection_address')}</Description>}
      <InnerContainer>
        <div>
          <SubHeader>{restaurant.name}</SubHeader>
          <AddressContainer>
            <Text>
              {firstLine} {secondLine}
            </Text>
            <Text>
              {thirdLine ? `${thirdLine} •` : null} {postcode}
            </Text>
            <Text>{city}</Text>
          </AddressContainer>
        </div>

        {!hideMapButton && (
          <IconButton
            icon="locationPin"
            size={56}
            bordered={false}
            backgroundColor={{
              default: 'white',
              hover: theme.colors.brand,
            }}
            stroke={{
              default: theme.colors.brand,
              hover: 'white',
            }}
            onClick={e => {
              e.preventDefault()
              handleMapsSearch()
            }}
          />
        )}
      </InnerContainer>
    </Container>
  )
}
